import {
  Box, Flex, Image, Text,
} from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';

import AddApplicantIcon from 'assets/icons/add-applicant.svg';
import useApplicationContext from 'contexts/application/useApplicationContext';

export default function ApplicantTabs({ onAdd }: { onAdd: ()=> void }): JSX.Element {
  const { application } = useApplicationContext();
  const { applicationId, applicantId } = useParams();
  const navigate = useNavigate();

  const handleClick = (id: number): void => {
    if (!applicationId) return;
    navigate(`/application/${applicationId}/applicant/${id}`);
  };

  return (
    <Flex gap={3}>
      {application.applicants?.map((a) => {
        const isActive = a.id === Number(applicantId);
        return (
          <Box
            key={a.id}
            px={6}
            py={3}
            mb='50px'
            borderWidth='0px'
            borderRadius='xl'
            bg={isActive ? '#1e1b1b' : '#f4f4f4'}
            cursor='pointer'
            onClick={() => handleClick(a.id!)}
          >
            <Text
              fontWeight={isActive ? 'bold' : 'medium'}
              color={isActive ? 'white' : 'inherit'}
              textTransform='capitalize'
            >
              {a.firstName} {a.lastName}
            </Text>
            <Box display='flex' alignItems='center'>
              <Box
                w='8px'
                h='8px'
                borderRadius='full'
                bg={isActive ? '#ffffff' : '#A8A8A8'}
                display='inline-block'
                mr={2}
              />
              <Text fontSize='xs' color={isActive ? '#ffffff' : '#A8A8A8'}>
                {a.files?.length ?? 0} Files
              </Text>
            </Box>
          </Box>
        );
      })}
      <Box
        w='70px'
        h='70px'
        bg='#F4F4F4'
        borderRadius='xl'
        cursor='pointer'
        _hover={{ bg: 'gray.100' }}
        onClick={onAdd}
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <Image src={AddApplicantIcon} width='30px' />
      </Box>
    </Flex>
  );
}
